import styled from 'styled-components';

export const QRStyled = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 65%;
  background: #222;
`;
